export default "__VITE_ASSET__9547875e__"